// ChatHeader — Presentational header bar for the AI chat modal: the assistant
// avatar, the "Ask Dan — AI Assistant" title row, and the close (X) button.
//
// Extracted verbatim from `AIChatBot.js` (the header block of the modal) as
// part of the behavior-preserving refactor (issue #240). Render-only, wrapped
// in React.memo. Markup, gradient background, rounded top corners, title text,
// and the close button styles are identical to the source. The close button is
// wired to the `onClose` callback owned by the container, exactly as the source
// did.
//
// Props:
//   onClose - callback invoked when the close (X) button is clicked
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { X, Bot } from 'lucide-react';

export const ChatHeader = React.memo(function ChatHeader({ onClose }) {
  return (
    <div style={{
      padding: '20px',
      borderBottom: '1px solid #e5e7eb',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: 'linear-gradient(135deg, #667eea, #764ba2)',
      color: 'white',
      borderRadius: '16px 16px 0 0'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{
          width: '40px', height: '40px',
          background: 'rgba(255,255,255,0.2)',
          borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <Bot size={20} />
        </div>
        <div>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>Ask Dan — AI Assistant</h3>
          <p style={{ margin: 0, fontSize: '14px', opacity: 0.9 }}>Your personal travel planner</p>
        </div>
      </div>
      <button onClick={onClose} style={{
        background: 'none', border: 'none', color: 'white', cursor: 'pointer',
        padding: '8px', borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <X size={20} />
      </button>
    </div>
  );
});

export default ChatHeader;
